import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const LoginBonus = {
  namespaced: true,
  state: {
    histories: null,
    girl: []
  },
  getters: {
    histories: state => state.histories,
    girl: state => state.girl
  },
  mutations: {
    UPDATE_LOGIN_BONUS(state, payload) {
      state.histories = payload['histories']
      state.girl = payload['girl']
    }
  },
  actions: {
    /**
     * スタンプ獲得履歴の取得
     *
     * @param {*} param0
     * @param {*} payload
     */
    async actionFetchLoginBonus({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      const isAll = payload.isAll
      let res = null
      if (token !== '') {
        res = await APIClient.getLoginBonus(token, accTime, userId, isAll)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_LOGIN_BONUS', res.data.data)
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
